import {TailwindContents} from '@wandb/weave/components/Tailwind';
import React from 'react';

import {TABLE_ROW_HEIGHT} from '../../util/constants';

export const RunsHiddenByFiltersBanner = () => {
  return (
    <TailwindContents>
      <div
        style={{height: TABLE_ROW_HEIGHT}}
        className="night-aware flex items-center justify-center overflow-hidden bg-white px-3 text-center text-sm italic leading-5 text-moon-500 dark:bg-moon-900 dark:text-moon-400 border-y border-moon-200 dark:border-moon-700">
        <span
          className="min-w-0 max-w-full truncate"
          title="Additional search results are hidden by active filters">
          Additional search results are hidden by active filters
        </span>
      </div>
    </TailwindContents>
  );
};
